import React, { PureComponent } from "react";

//import { TTP_API_URL } from "Config";
import styles from "./Survey.local.scss";
import classnames from "classnames";
import _ from "i18n";
import { extarctSurveyStats } from "Utils";

export default class SurveyComponent extends PureComponent {
  getAcceptedTypes() {
    return ["text/xml"];
  }

  renderStats(choiceId) {
    const { stats } = this.props;

    if (!stats || stats.length === 0) {
      return null;
    }

    const data = extarctSurveyStats(stats, choiceId);
    const { sum, currentCount } = data;

    return (
      <span className={styles.stats}>
        {sum === 0 ? 0 : Math.round((currentCount / sum) * 100)}%
      </span>
    );
  }

  renderSurvey() {
    const { items, selectResponse, selectedChoice, lng } = this.props;
    if (
      !items ||
      !items[0] ||
      !items[0].dimensions ||
      !items[0].dimensions[0].questions ||
      !items[0].dimensions[0].questions[0].choices ||
      !items[0].dimensions[0].questions[0].choices.length > 0
    ) {
      return <div className={styles.notFound}>{_("No activated Survey")}</div>;
    }
    let i = 0;
    return (
      <div className={styles.content}>
        <p>{items[0].dimensions[0].questions[0].text[lng]}</p>
        <ul>
          {items[0].dimensions[0].questions[0].choices.map(choice => {
            return (
              <li
                className={selectedChoice === choice.id ? styles.selected : ""}
                onClick={selectResponse.bind(this, choice.id)}
              >
                <span>{++i}</span>
                {choice.text[lng]}
                {this.renderStats(choice.id)}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  render() {
    const { fetching, navCommunity } = this.props;
    if (fetching) {
      return (
        <div
          className={classnames(
            styles.survey,
            parseInt(navCommunity.id, 10) === 8 ||
            parseInt(navCommunity.id, 10) === 9
              ? styles.surveyCom
              : ""
          )}
        >
          <div className={styles.header}>
            <span className={styles.hTitle}>{_("Mini Quiz")}</span>
            <span className={styles.app}>Survey</span>
          </div>
          <div className={styles.content}>
            <div>
              <div className={styles.fetching} />
              <div className={styles.fetching} />
            </div>
            <ul className={styles.fetchingResponse}>
              <li />
              <li />
              <li />
            </ul>
          </div>
        </div>
      );
    }
    return (
      <div
        className={classnames(
          styles.survey,
          parseInt(navCommunity.id, 10) === 8 ||
          parseInt(navCommunity.id, 10) === 9
            ? styles.surveyCom
            : ""
        )}
      >
        <div className={styles.header}>
          <span className={styles.hTitle}>{_("Mini Quiz")}</span>
          <span className={styles.app}>Survey</span>
        </div>
        {this.renderSurvey()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Survey/SurveyComponent.js